interface FooterNavItem {
  href: string
  name: string
  target?: string
}

interface FooterSection {
  label: string
  items: FooterNavItem[]
}

export interface FooterDataProps {
  logoUrl: string
  description: string
  mailingListLabel: string
  sections: FooterSection[]
  brand: string
}

export const footerData: FooterDataProps = {
  logoUrl: 'lykstage-logo',
  description: 'Watch. Create. Earn. Repeat.',
  mailingListLabel: 'Join our mailing list for the latest updates',
  sections: [
    {
      label: 'Useful Links',
      items: [
        { href: '/auth/login', name: 'Login' },
        { href: '/what-is-lykstage', name: 'About Us' },
        { href: '/viewer-earnings', name: 'Viewer Earnings' },
        { href: '/creator-guide', name: 'Creator\'s Guide' },
        { href: '/faqs', name: 'FAQs' },
        { href: 'https://blog.lykstage.com/', name: 'Blog', target: '_blank' },
        { href: '/creator-revenue-assurance-program', name: 'Creator Earnings Assurance Program' },
      ],
    },
    {
      label: 'Social Links',
      items: [
        { href: 'https://www.linkedin.com/company/lykapp/', name: 'LinkedIn' },
        {
          href: 'https://www.instagram.com/lykstage/',
          name: 'Instagram',
        },
        { href: 'https://www.facebook.com/Lykstage/', name: 'Facebook' },
        { href: 'https://discord.gg/R8urfJM4Qb', name: 'Join our Discord' },
      ],
    },
    {
      label: 'Legal',
      items: [
        { href: '/termsofservice', name: 'Terms of Service', target: '_blank' },
        { href: '/privacypolicy', name: 'Privacy Policy', target: '_blank' },
        { href: '/community', name: 'Community Guidelines', target: '_blank' },
        { href: '/dmca', name: 'DMCA', target: '_blank' },
      ],
    },
  ],
  brand: 'LYKSTAGE',
}
